import jquery from 'jquery';
window.jQuery = jquery;
window.$ = jquery;

import JqueryFunctions from '../../../assets/js/Utility/JqueryFunctions.js';
JqueryFunctions();

// https://github.com/stefanpenner/es6-promise
require('es6-promise').polyfill();

import axios from 'axios';
window.axios = axios;

import Vue from 'vue';
Vue.prototype.$http = axios;
window.Vue = Vue;

import JqueryTools from '../../../assets/js/Libs/JqueryTools.js';
import viewport_size from '../../../assets/3rd_party/viewportSize/viewportSize-min.js';

import ev_widgets from '../../../assets/top/rcmg_users_v2/evolok/ev-widgets/3.5.18/ev-widgets.min.js'; 
import EvLib from '../../../assets/js/Libs/EvolokLibrary.js';
EvLib();

import waypoints from '../../../assets/3rd_party/waypoints/lib/jquery.waypoints';
import inview from '../../../assets/3rd_party/waypoints/lib/shortcuts/inview.js';
import typeahead from '../../../assets/3rd_party/typeahead/0.11.1/typeahead.bundle.js';

import FlexSlider from 'flexslider';